import React, { Component, useState } from "react";
import "./Wealth.module.css";

class Wealth extends Component {
    onClickItem = (id) => {
        if (this.state.activeIDs.indexOf(id) != -1 ){
            var array = [...this.state.activeIDs];
            var index = this.state.activeIDs.indexOf(id);
            array.splice(index, 1);
            this.setState({activeIDs: array});
        }
        else {
            this.setState({activeIDs: [...this.state.activeIDs, id]});
        }
    }

    state = {
        activeIDs: []
    };

    render () {
        return (
            <div className="Wealth">
                <h2>ЦЕННОСТИ ЭР-Телеком Холдинг</h2>
                <div className="WealthItems">
                    {console.log(this.state.activeIDs)}
                    <div className={`WealthItem ${this.state.activeIDs.indexOf(1) != -1 ? 'Open' : ''}`} onClick={() => this.onClickItem(1)}>
                        <div className="WealthItemHeader">
                            <p className="WealthItemName">
                                Вызов
                            </p>
                            <p className="WealthItemSlogan">
                                Возможно всё!
                            </p>
                        </div>
                        <div className="WealthItemIMG">
                            <img src={require('./img/Challenge.png')} />
                            <p>Готовность выходить за рамки привычного, ставить амбициозные цели и 
                                находить нестандартные решения, это смелость и стремление к развитию. 
                                <p className="WealthSecondSlogan">Мы – компания, которая принимает вызов!</p>
                            </p>
                        </div>
                    </div>
                    <div className={`WealthItem ${this.state.activeIDs.indexOf(2) != -1 ? 'Open' : ''}`} onClick={() => this.onClickItem(2)}>
                        <div className="WealthItemHeader">
                            <p className="WealthItemName">
                                Надежность
                            </p>
                            <p className="WealthItemSlogan">
                                Сказано = сделано!
                            </p>
                        </div>
                        <div className="WealthItemIMG">
                            <img src={require('./img/Reliability.png')} />
                            <p>Способность выполнять обязательства и гарантировать  высокое качество.
                                <p className="WealthSecondSlogan">Мы – компания, которая гарантирует высокое качество!</p>
                            </p>
                        </div>
                    </div>
                    <div className={`WealthItem WealthItem--last ${this.state.activeIDs.indexOf(3) != -1 ? 'Open' : ''}`} onClick={() => this.onClickItem(3)}>
                        <div className="WealthItemHeader">
                            <p className="WealthItemName">
                                Честность
                            </p>
                            <p className="WealthItemSlogan">
                                Мы честная компания
                            </p>
                        </div>
                        <div className="WealthItemIMG">
                            <img src={require('./img/Honesty.png')} />
                            <p>Честность – основа доверия: открытость, прозрачность и прямой диалог с клиентами, коллегами и партнерами.
                                <p className="WealthSecondSlogan">Мы – компания, которая открыто говорит о тех вызовах, которые стоят перед нами, и о потенциале наших возможностей.</p>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Wealth;



// WEBPACK FOOTER //
// ./src/components/Wealth/index.js